import { React, useState,useReducer } from "react";
import { useDispatch, useSelector } from "react-redux";
import SearchIcon from "../../../../assets/search.svg";
import IconButton from "@mui/material/IconButton";
import Notification from "../../../../assets/notification.svg";
import MenuIcon from "@mui/icons-material/Menu";
import User from "../../../../assets/user.svg";
import "./header.scss";
import store from "../../../../reducers/store";
import "../../../shared/Common/darklayout.scss";
import { PublicClientApplication } from "@azure/msal-browser";
import axios from "axios"
import authHeader from "../../../../services/auth-header";
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import SharedUtils from "../../Common/utils";
import { MsalProvider } from "@azure/msal-react";
import { GoogleLogin } from 'react-google-login';

const Header = () => {
    const dispatch = useDispatch();
    const sidebarState = useSelector((state) => state.header.isOpen);

    const [show_user_menu, setShowMenu] = useState(false);
    const [notwork_down, setNetworkDown] = useState(false);

    const [, forceUpdate] = useReducer(x => x + 1, 0);

    store.subscribe(() => {
        forceUpdate();
    });


    const handleSidebarMenu = () => {
        dispatch({
            type: "TRIGGER_SIDEBAR_MENU",
            payload: !sidebarState,
        });
    };

    const showUserMenu = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setShowMenu(!show_user_menu);
 
    }



    const hideUserMenu = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setShowMenu(false);
    }



    const doBtns = (token) => {


        let type = localStorage.getItem("type");
        var btns = [];
        let ids = JSON.parse(localStorage.getItem("ids"));


        ids.data['client_id'].forEach((x, y) => {
            btns.push({
                label: x.client_name,

                style: '{"color":"#000"}',
                className: 'ssoClBtn hhkj',
                onClick: async () => {

                    document.body.classList.add('fadeswitch');
                    setTimeout( async () => {
                        let error = await SharedUtils.doSsoLogin(x, token, type);
                        if (error != undefined && error != "") {
                            window.location = '/login';
                        }
                    }, 200);
                }
            })
        })


        confirmAlert({
            title: 'Switch Account',
            message: 'Please choose a Customer ID to sign in',
            buttons: btns,
            overlayClassName: 'ssoclselect opacity7',
            closeOnClickOutside: true,

        });
    }



    const switch_account = (event) => {

        let token = "";
        let type = localStorage.getItem("type");


        if (type == "azure") {

            let msalConfig = {

                auth: {
                    clientId: window.config.azure_clientId,
                    authority: "https://login.microsoftonline.com/common",
                    redirectUri: "/",
                },
                cache: {
                    cacheLocation: "sessionStorage",
                    storeAuthStateInCookie: false,
                }
            };


            let pca = new PublicClientApplication(msalConfig);

            let loginRequest = {
                scopes: ["User.Read"],
                account: pca.getAllAccounts().find(account => account['homeAccountId'] == localStorage.getItem("account_id")),
            };


            pca.acquireTokenSilent(loginRequest).then((response) => {
                token = response.accessToken;

                doBtns(token);

            }).catch((error) => {
                window.location = '/login';
            });

        }
        else if (type == "google") {

            window.google.accounts.id.initialize({
                client_id: window.config.googlesso_clientId,
                callback: scc,
                auto_select: true,
            });

            window.google.accounts.id.prompt((notification) => {
                if (notification.isNotDisplayed()) {
                    document.cookie = `g_state=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
                    window.google.accounts.id.prompt()
                }
            });
        }
    }


    const scc = (res) => {
        doBtns(res.credential);
    }


    const logout = (event) => {

        localStorage.clear();

        try {
            window.google.accounts.id.disableAutoSelect();
        }
        catch (e) {
        }


        window.location = '/login';
    }



    return (
        <>

            <div class="nonetworkbar" style={{ display: notwork_down ? "block": "none" }} >Panel network error. Please contact support if the issue presists.</div>

            <nav className="navbar navbar-expand-lg navbar-light" id="header" onClick={hideUserMenu}>
            
                <div className="navbar-collapse" id="navbarSupportedContent">
                    <div className="navbar-hamburger-menu">
                        <IconButton
                            onClick={handleSidebarMenu}
                            aria-label="side bar menu handler"
                        >
                            <MenuIcon sx={{ color: "#8d91a9" }} />
                        </IconButton>
                    </div>
                    {/*<form className="d-flex me-auto">*/}
                    {/*    <input*/}
                    {/*        className="form-control me-2"*/}
                    {/*        type="search"*/}
                    {/*        placeholder="Search"*/}
                    {/*        aria-label="Search"*/}
                    {/*    />*/}
                    {/*    <img*/}
                    {/*        src={SearchIcon}*/}
                    {/*        alt="search-icon"*/}
                    {/*        width="auto"*/}
                    {/*        height="auto"*/}
                    {/*    />*/}
                    {/*</form>*/}

                </div>
                <ul className="navbar-nav  mb-2 mb-lg-0 fright">
                    {/*<li className="nav-item"  >*/}
                    {/*    <a className="nav-link">*/}
                    {/*        <img*/}
                    {/*            src={Notification}*/}
                    {/*            alt="notification"*/}
                    {/*            width="auto"*/}
                    {/*            height="auto"*/}
                    {/*        />*/}
                    {/*    </a>*/}
                    {/*</li>*/}
                    <li className="nav-item">
                        <a className="nav-link pt-1" data-testid={"user"}>
                            <img src={User} alt="user" width="auto" height="auto" />
                        </a>
                    </li>
                    <div className="dotmenucontainer">
                        <li className="nav-item" onClick={showUserMenu} data-testid={"usermenu"}>
                            <a className="nav-link blue">
                                <div className="client_name"> {localStorage.getItem("client_name")}</div>
                                <div>{store.getState().auth.username}</div>
                            </a>
                        </li>

                        <div className="dotmenu" style={{ display: (show_user_menu) ? "block" : "none" }} >




                            <div data-testid={"switch account"} className="dodmenuitem" onClick={switch_account}
                                style={{
                                    "display": localStorage.getItem("ids") &&
                                        JSON.parse(localStorage.getItem("ids")).data['client_id'].length > 1 
                                        ? "block" : "none"
                                }}>Switch Account</div>
                     
                            <hr className="menuhr" />


                            <div data-testid={"logout"} className="dodmenuitem" onClick={logout}>Logout</div>





                        </div>

                        <div
                            className={store.getState().states.showReadonly === true ? "readonlyBox" : "readonlyBox readonlyBoxOff"}
                            onClick={
                                () => {
                                    dispatch({
                                        type: "TRIGGER_READONLY_POPUP",
                                        payload: false,
                                    });

                                }
                            }>

                            <div className="fleft"><b style={{ color: "red", fontSize: "14px" }} >Access denied</b>
                                <br />You need permission to perform this action</div>
                            <div className="fright readonlyBoxClose">Close</div>
                        </div>
                    </div>

                </ul>
            </nav>
        </>
    );
};

export default Header;
